import cloneDeep from 'lodash/cloneDeep';
import type { DownloadIdentity } from '@mimir/client-common/fileSync/downloadIdentity';
import type { LocalMediaState } from '@mimir/client-common/fileSync/premiereTypes';
import { getOngoingDownloadId } from '@mimir/client-common/model/ongoingDownload';
import Vue, { reactive } from 'vue';

export function isLocalMediaAvailable(downloadIdentity: DownloadIdentity) {
  const localMediaState = getLocalMediaState(downloadIdentity);
  return localMediaState.isAvailableLocally || false;
}

export function getLocalMediaState(downloadIdentity: DownloadIdentity): LocalMediaState {
  const dlId = getOngoingDownloadId(downloadIdentity, null);
  if (localMediaStatesGlobalPrivate[dlId] === undefined) {
    Vue.set(localMediaStatesGlobalPrivate, dlId, { });
  }
  return localMediaStatesGlobalPrivate[dlId];
}

export function setLocalMediaState(downloadIdentity: DownloadIdentity, localMediaState: LocalMediaState) {
  const dlId = getOngoingDownloadId(downloadIdentity, null);
  Vue.set(localMediaStatesGlobalPrivate, dlId, cloneDeep(localMediaState));
}

// End of public API

const localMediaStatesGlobalPrivate : Record<string, LocalMediaState> = reactive({ });
